import { Component, OnInit, NgZone, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormdataService } from '@services/formdata.service';
import { SaveService } from '@services/save.service';
import { FormBuilder, FormGroup, FormArray, FormControl } from '@angular/forms';
import * as _ from 'lodash';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
@Component({
  selector: 'app-caudio',
  templateUrl: './caudio.component.html',
  styleUrls: ['./caudio.component.sass']
})
export class CaudioComponent implements OnInit {

  error: any = { 'name': ''};
  response:any=[];
  public config: DropzoneConfigInterface = {
    acceptedFiles: 'audio/*',
    clickable: true,
    maxFiles: 1
  };
  component="";
  application="";
  appCreateForm: FormGroup;
  app_create = true;
  btn_process=false;
  constructor(private fb: FormBuilder, private _saveService: SaveService, private _formdataService: FormdataService, private route: ActivatedRoute, private _global: GlobalService, private router: Router) {
    this.component = this._global.COMPONENTS_SMN;
    this.application = "audio";
    this.appCreateForm = this.fb.group({
      name: [],
      description:[]
    });
  }

  ngOnInit() {
  }
  public onUploadInit(args: any): void {
    args["options"]["params"] = this._global.getUploadParams(this.application, this.component, this.application, '');
  }
  public onUploadError(args: any): void {
    this._global.showMessage({ type: 'warning', message: args[1] });
  }

  public onUploadSuccess(args: any): void {
    let res = JSON.parse(args[1]);
    if (this._global.getVal(res, 'id', '')) {
      this.app_create = false;
      this.response['name'] = this._global.getVal(res, 'name', '');
      this.response['id'] = this._global.getVal(res, 'uid', '');
    }
   
  }
  public onUploadProcessing(args: any){
  
   
  }
 
  update() {
    let p = this._global.generateParams(this.appCreateForm.value, []);
    this.error = { 'name': '' };
    this.btn_process = true;
    p['component'] = this.component;
    p['application'] = this.application;
    p = this._global.paramsRemoveNull(p);
    p['id'] = this._global.getVal(this.response, 'id', '');
    this._saveService.appUpdate(p).subscribe(
      data => {

        let severity = 'success';
        let message = '';
        if (this._global.getVal(data, 'status', '') == 1) {
          message = this._global.getVal(data, 'message.info', '');
          this._global.showMessage({ type: severity, message: message });

          this.router.navigate(['/my/' + this.application]);
        } else {
          this.btn_process = false;
          message = this._global.getVal(data, 'message.error', '');
          severity = 'warning';
          for (let key in data["errors"]) {
            this.error[key] = this._global.getVal(data, 'errors.' + key + '.message', '');
          }
          this._global.showMessage({ type: severity, message: message });
        }

      },
      error => {
        console.log("error", JSON.stringify(error));
      });

  }
}
